import { render, staticRenderFns } from "./SendSMSDialog.vue?vue&type=template&id=fb5fd4e0"
import script from "./SendSMSDialog.vue?vue&type=script&lang=ts"
export * from "./SendSMSDialog.vue?vue&type=script&lang=ts"
import style0 from "./SendSMSDialog.vue?vue&type=style&index=0&id=fb5fd4e0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports